import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { CustomJsService } from "src/app/shared/custom-js.service";
import { SportService } from "src/app/sports/sport.service";

@Component({
    selector: "app-schedule-sport-detail",
    templateUrl: "./schedule-sport-detail.component.html",
    styleUrls: ["./schedule-sport-detail.component.scss"],
})
export class ScheduleSportDetailComponent implements OnInit {
    public sport: any = null;

    constructor(
        private activetedRoute: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private sportService: SportService,
        private customJsService: CustomJsService
    ) {
        this.spinner.show();

        this.activetedRoute.params.subscribe((params) => {
            if (params === null || params === undefined) {
                setTimeout(() => {
                    this.spinner.hide();
                }, 500);

                return false;
            }

            this.getSport(params.id);
        });
    }

    ngOnInit() {}

    getSport(id: number) {
        this.sportService.getSportById(id).subscribe((res) => {
            this.sport = res;
            setTimeout(() => {
                this.spinner.hide();
            }, 500);
        });
    }
}
